import { BASE_URL } from '@src/utils/constants';

type UploadImageArgs = {
  url: string;
  method: 'POST';
  body: FormData;
};

type UploadImageFn = (args: UploadImageArgs) => {
  unwrap: () => Promise<{ success?: boolean; message?: string }>;
};

export const uploadImageByPath = async (
  uploadImage: UploadImageFn,
  file: File,
  path: string
): Promise<string> => {
  if (!path) throw new Error('Upload path not specified');

  const formData = new FormData();
  formData.append('file', file);

  const url = `${BASE_URL}/v1/documents/images/upload/${path}`;

  const res = await uploadImage({
    url,
    method: 'POST',
    body: formData,
  }).unwrap();

  if (!res?.success || !res?.message) {
    throw new Error('Image upload failed');
  }

  return res.message;
};
